import { render, staticRenderFns } from "./StaffDraft.vue?vue&type=template&id=101e7ef5&"
import script from "./StaffDraft.vue?vue&type=script&lang=js&"
export * from "./StaffDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports